import "./style.less";

const PriceRule = (props) => {
  const { price } = props;
  const { kwhPrice } = price;

  let w150 = 7.0;
  let w250 = 4.8;
  let w300 = 4.0;
  let w400 = 3.0;
  let w660 = 1.8;

  if (kwhPrice >= 45 && kwhPrice <= 55) {
    w150 = 6.5;
    w250 = 4.6;
    w300 = 3.6;
    w400 = 2.7;
    w660 = 1.6;
  } else if (kwhPrice > 55 && kwhPrice <= 60) {
    w150 = 6.0;
    w250 = 4.2;
    w300 = 3.5;
    w400 = 2.5;
    w660 = 1.5;
  } else if (kwhPrice > 60 && kwhPrice <= 70) {
    w150 = 5.5;
    w250 = 3.5;
    w300 = 3.0;
    w400 = 2.0;
    w660 = 1.2;
  } else if (kwhPrice > 70 && kwhPrice <= 80) {
    w150 = 5.0;
    w250 = 3.2;
    w300 = 2.5;
    w400 = 1.9;
    w660 = 1.1;
  } else if (kwhPrice > 80 && kwhPrice <= 100) {
    w150 = 4.5;
    w250 = 3.0;
    w300 = 2.5;
    w400 = 1.9;
    w660 = 1.1;
  } else if (kwhPrice > 100) {
    w150 = 4.0;
    w250 = 2.6;
    w300 = 2.2;
    w400 = 1.7;
    w660 = 1.0;
  }

  let w150m = w150 * 60;
  let w250m = w250 * 60;
  let w300m = w300 * 60;
  let w400m = w400 * 60;
  let w660m = w660 * 60;


  return (
    <div className="price-rule-table">
      <div>
        不同功率充电时间参考：
      </div>
      <div>
        <table>
          <tr>
            <td>功率</td>
            <td>1元对应充电时长</td>
          </tr>
          <tr>
            <td>150w</td>
            <td>约{w150}小时（{w150m}分钟）</td>
          </tr>
          <tr>
            <td>250w</td>
            <td>约{w250}小时（{w250m}分钟）</td>
          </tr>
          <tr>
            <td>300w</td>
            <td>约{w300}小时（{w300m}分钟）</td>
          </tr>
          <tr>
            <td>400w</td>
            <td>约{w400}小时（{w400m}分钟）</td>
          </tr>
          <tr>
            <td>600w</td>
            <td>约{w660}小时（{w660m}分钟）</td>
          </tr>
        </table>
      </div>
      <br />
      <div className="price-rule-hint">
        <p>请根据功率自主选择充电金额。</p>
        <p>平台会实时计费，充电结束后根据实际用电情况，自动退费，请放心使用。</p>
      </div>
    </div>
  )
}

export default PriceRule